import React, {useEffect, useState } from 'react';
import { useSiteTagsQuery, useSiteTagsLazyQuery } from '../../generated/graphql';
import {GraphQlSelect} from "./GraphQlSelect";
import {GraphQlSelectId} from "./GraphQlSelectId";

export const SiteTagSelect = (props: any): JSX.Element => {
    const [tagFilter,setTagFilter] = useState('');
    const variables = {};
    if(tagFilter) { variables.name = '%'+tagFilter+'%'; }
    const siteTagQueryResult = useSiteTagsQuery({variables:variables});
    const [siteTagPull,siteTagPullResult] = useSiteTagsLazyQuery();
    //const localValues
    const renderOptionString = (item)=>{
        if(typeof item != 'string') {
            return item?item.section+': '+item.name:'';
        }
    }
    const tagProps = (item)=>{
        return {className:'section-'+(item?.section?.toLowerCase())};
    }
/*    useEffect(()=> {
        if(props.value) {
            // if we're loading for the first time, and there's a value then we need to fetch the relevant entries
            siteTagPull({variables:{ids:["1","2","3","4","5"]}}).then(

            )

        }
    })*/
    /*useEffect(()=>{
        if(props.valueIsId && props.value) {
            siteTagPull({variables:{ids:props.value}});
        }
    },[]);*/
    /*useEffect(()=>{
        setFullValues(siteTagPullResult?.data?.siteTags?.data);
    },[siteTagPullResult?.data?.siteTags?.data]);*/
// annoyingly, onload we have no idea what the hell the selected tags are o_O
    //setTagFilter={setTagFilter}
    //getTagProps={tagProps}
    console.log('value is',props.value);
    return props.valueIsId?
        <GraphQlSelectId {...props} renderOptionString={renderOptionString} queryResult={siteTagQueryResult} labelField="name" />:
        <GraphQlSelect {...props} renderOptionString={renderOptionString} queryResult={siteTagQueryResult} labelField="name" />;
    //return <GraphQlTagSelect {...props}
}